import React from 'react';
import { PaarPassportSection } from '../../sections';

const PaarPassportContainer = () => {
  return (
    <>
      <PaarPassportSection />
    </>
  );
};

export default PaarPassportContainer;
